import {
  Alert,
  Heading,
  Paragraph,
  Skeleton,
} from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";
import { Page } from "@/components";

import { useSelskaper } from "../selskap/SelskapContext";
import { InnstillingerForm } from "./InnstillingerForm";
import { useInnstillingerData } from "./innstillingerData";

export const InnstillingerPage = () => {
  const { t } = useTranslation();
  const { active, isLoadingSelskaper } = useSelskaper();

  const {
    innstillinger,
    isLoading: isLoadingInnstillinger,
    error,
  } = useInnstillingerData(active?.organisasjonsnummer);

  const lasterSide = isLoadingSelskaper || !active || isLoadingInnstillinger;
  return (
    <Page withBackLink>
      <div className="max-w-card space-y-9">
        <Heading level={1} data-size="lg">
          {t("pages.innstillinger.tittel")}
        </Heading>
        <Paragraph>{t("pages.innstillinger.beskrivelse")}</Paragraph>

        {error && (
          <Alert data-color="danger">
            <Heading data-size="xs">
              {t("pages.innstillinger.feil-ved-henting.tittel")}
            </Heading>
            <Paragraph>
              {t("pages.innstillinger.feil-ved-henting.beskrivelse")}
            </Paragraph>
          </Alert>
        )}

        {lasterSide ? (
          <Skeleton width={600} height={780} />
        ) : (
          <InnstillingerForm innstillinger={innstillinger} />
        )}
      </div>
    </Page>
  );
};
